import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import Solution from "@/components/landing/Solution";
import HowItWorks from "@/components/landing/HowItWorks";
import Pricing from "@/components/landing/Pricing";
import Marketplace from "@/components/landing/Marketplace";
import FAQs from "@/components/landing/FAQs";
import Waitlist from "@/components/landing/Waitlist";
import Footer from "@/components/landing/Footer";
import FloatingActions from "@/components/landing/FloatingActions";

export default function Landing() {
  return (
    <div
      className="min-h-screen text-zyp-navy selection:bg-zyp-highlight/20 selection:text-zyp-navy"
      data-testid="landing-page"
    >
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <Solution />
        <HowItWorks />
        <Pricing />
        <Marketplace />
        <FAQs />
        <Waitlist />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
